(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aline-advertorial-chiro"] && !Shopify.designMode) return;
  try {
    
  /* Append the visitor's A/B variant to every advertorial CTA (ref=chiro links). */
  (function () {
    var v = window.__chiroAB;
    if (v !== 'a' && v !== 'b') return;
    var links = document.querySelectorAll('a[href*="ref=chiro"]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href');
      if (href && href.indexOf('ab=') === -1) links[i].setAttribute('href', href + '&ab=' + v);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aline-advertorial-japan"] && !Shopify.designMode) return;
  try {
    
  /* Append the visitor's A/B variant to every advertorial CTA (ref=japan links). */
  (function () {
    var v = window.__japanAB;
    if (v !== 'a' && v !== 'b') return;
    var links = document.querySelectorAll('a[href*="ref=japan"]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href');
      if (href && href.indexOf('ab=') === -1) links[i].setAttribute('href', href + '&ab=' + v);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aline-advertorial-menoside"]) return;
  try {
    
  /* FAQ accordion */
  (function () {
    document.querySelectorAll('[data-advm-acc]').forEach(function (item) {
      var btn = item.querySelector('.advm__faq-q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  })();

  /* offer-box HH:MM:SS countdown (shares the storewide offer deadline) */
  (function () {
    var el = document.querySelector('[data-advm-timer]');
    if (!el) return;
    var hours = parseFloat(el.getAttribute('data-hours')) || 5, KEY = 'aline_offer_deadline', now = Date.now();
    var dl = parseInt(localStorage.getItem(KEY), 10);
    if (!dl || isNaN(dl) || dl < now) { dl = now + hours * 3600000; try { localStorage.setItem(KEY, dl); } catch (e) {} }
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var t = setInterval(function () {
      var s = Math.max(0, Math.floor((dl - Date.now()) / 1000));
      el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60);
      if (s <= 0) clearInterval(t);
    }, 1000);
  })();

  /* mobile sticky offer popup — reveals after the first section, dismissible for the session */
  (function () {
    var bar = document.querySelector('[data-advm-sticky]');
    if (!bar) return;
    if (window.matchMedia('(min-width:761px)').matches) return;
    try { if (sessionStorage.getItem('aline_sticky_closed') === '1') return; } catch (e) {}
    var first = document.querySelector('.advm__sec');
    var closeBtn = bar.querySelector('[data-advm-sticky-close]');
    if (closeBtn) closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      bar.classList.remove('is-visible');
      try { sessionStorage.setItem('aline_sticky_closed', '1'); } catch (e2) {}
    });
    var shown = false;
    function check() {
      if (shown) return;
      var past = first ? (first.getBoundingClientRect().top < window.innerHeight * 0.5) : (window.pageYOffset > 700);
      if (past) { shown = true; bar.classList.add('is-visible'); window.removeEventListener('scroll', check); }
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  })();

  /* Carry ad / UTM / click-id attribution onto every product CTA */
  (function () {
    var v = window.__advAB, params;
    try { params = new URLSearchParams(location.search); } catch (e) { params = null; }
    var CARRY = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'ad'];
    var extra = [];
    if (params) {
      CARRY.forEach(function (k) {
        var val = params.get(k);
        if (val) { val = val.replace(/[<>"']/g, '').slice(0, 200); if (val) extra.push([k, val]); }
      });
    }
    var links = document.querySelectorAll('a[href*="ref=menoadv"]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href'); if (!href) continue;
      if ((v === 'a' || v === 'b') && href.indexOf('ab=') === -1) href += '&ab=' + v;
      for (var j = 0; j < extra.length; j++) {
        var k = extra[j][0];
        if (new RegExp('[?&]' + k + '=').test(href)) continue;
        href += '&' + k + '=' + encodeURIComponent(extra[j][1]);
      }
      links[i].setAttribute('href', href);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aline-advertorial-menoside2"]) return;
  try {
    
  /* Countdown, sticky popup and ad-parameter passthrough for advertorial #2.
     Uses its own data-adv2-* hooks so it never binds to advertorial #1. */
  (function () {
    var el = document.querySelector('[data-adv2-timer]');
    if (el) {
      var hours = parseFloat(el.getAttribute('data-hours')) || 5;
      var KEY = 'aline_offer_deadline', now = Date.now();
      var dl = parseInt(localStorage.getItem(KEY), 10);
      if (!dl || isNaN(dl) || dl < now) { dl = now + hours * 3600000; try { localStorage.setItem(KEY, dl); } catch (e) {} }
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var t = setInterval(function () {
        var s = Math.max(0, Math.floor((dl - Date.now()) / 1000));
        el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60);
        if (s <= 0) clearInterval(t);
      }, 1000);
    }

    var bar = document.querySelector('[data-adv2-sticky]');
    if (bar) {
      var closed = false;
      try { closed = sessionStorage.getItem('aline_adv2_sticky_closed') === '1'; } catch (e) {}
      var close = bar.querySelector('[data-adv2-sticky-close]');
      if (close) close.addEventListener('click', function (ev) {
        ev.preventDefault(); bar.classList.remove('is-visible');
        try { sessionStorage.setItem('aline_adv2_sticky_closed', '1'); } catch (e) {}
      });
      var first = document.querySelector('.advm__sec');
      if (!closed && first && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (!e.isIntersecting && e.boundingClientRect.top < 0) bar.classList.add('is-visible'); });
        }, { threshold: 0 }).observe(first);
      } else if (!closed) { bar.classList.add('is-visible'); }
    }

    /* Carry the ad + UTM parameters from the landing URL through to the product page. */
    var CARRY = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'ad'];
    var params = null; try { params = new URLSearchParams(location.search); } catch (e) {}
    var extra = [];
    if (params) {
      CARRY.forEach(function (k) {
        var v = params.get(k);
        if (v) { v = v.replace(/[<>"']/g, '').slice(0, 200); if (v) extra.push([k, v]); }
      });
    }
    var links = document.querySelectorAll('a[href*="ref=menoadv2"]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href'); if (!href) continue;
      for (var j = 0; j < extra.length; j++) {
        var k = extra[j][0];
        if (new RegExp('[?&]' + k + '=').test(href)) continue;
        href += '&' + k + '=' + encodeURIComponent(extra[j][1]);
      }
      links[i].setAttribute('href', href);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aline-advertorial-sidepillow"] && !Shopify.designMode) return;
  try {
    
  /* Append the visitor's A/B variant to every advertorial CTA (ref=sidepillow links). */
  (function () {
    var v = window.__sidepillowAB;
    if (v !== 'a' && v !== 'b') return;
    var links = document.querySelectorAll('a[href*="ref=sidepillow"]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href');
      if (href && href.indexOf('ab=') === -1) links[i].setAttribute('href', href + '&ab=' + v);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aline-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  /* Customer reviews: sortable + progressive "show more" reveal. */
  (function () {
    document.querySelectorAll('[data-crev-list]').forEach(function (list) {
      var items = Array.prototype.slice.call(list.querySelectorAll('[data-crev-item]'));
      if (!items.length) return;
      var wrap = list.parentNode;
      var moreBtn = wrap.querySelector('[data-crev-more]');
      var sortSel = wrap.querySelector('[data-crev-sort]');
      var step = parseInt(list.getAttribute('data-step'), 10) || 5;
      var shown = Math.min(step, items.length);

      function num(el, attr) { return parseFloat(el.getAttribute(attr)) || 0; }
      var comparators = {
        recent:      function (a, b) { return num(a, 'data-index') - num(b, 'data-index'); },
        oldest:      function (a, b) { return num(b, 'data-index') - num(a, 'data-index'); },
        media:       function (a, b) { return (num(b, 'data-media') - num(a, 'data-media')) || (num(a, 'data-index') - num(b, 'data-index')); },
        helpful:     function (a, b) { return (num(b, 'data-helpful') - num(a, 'data-helpful')) || (num(a, 'data-index') - num(b, 'data-index')); },
        helpful_low: function (a, b) { return (num(a, 'data-helpful') - num(b, 'data-helpful')) || (num(a, 'data-index') - num(b, 'data-index')); },
        rating_high: function (a, b) { return (num(b, 'data-rating') - num(a, 'data-rating')) || (num(a, 'data-index') - num(b, 'data-index')); },
        rating_low:  function (a, b) { return (num(a, 'data-rating') - num(b, 'data-rating')) || (num(a, 'data-index') - num(b, 'data-index')); }
      };

      function render() {
        items.forEach(function (el, i) {
          var visible = i < shown;
          el.style.display = visible ? '' : 'none';
          el.classList.toggle('is-first', i === 0);
        });
        if (moreBtn) moreBtn.hidden = shown >= items.length;
      }

      function applySort(key) {
        var cmp = comparators[key] || comparators.recent;
        items.sort(cmp);
        items.forEach(function (el) { list.appendChild(el); });
        render();
      }

      if (moreBtn) moreBtn.addEventListener('click', function () {
        shown = Math.min(shown + step, items.length);
        render();
      });
      if (sortSel) sortSel.addEventListener('change', function () { applySort(sortSel.value); });

      render();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aline-listicle-2"]) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-countdown]');
    if (!el) return;
    var hours = parseFloat(el.getAttribute('data-hours')) || 5;
    var KEY = 'aline_offer_deadline';
    var now = Date.now();
    var deadline = parseInt(localStorage.getItem(KEY), 10);
    if (!deadline || isNaN(deadline) || deadline < now) {
      deadline = now + hours * 3600 * 1000;
      try { localStorage.setItem(KEY, deadline); } catch (e) {}
    }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var s = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
      el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      if (s <= 0) clearInterval(timer);
    }
    tick();
    var timer = setInterval(tick, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aline-listicle-editorial"]) return;
  try {
    
  /* ticking HRS/MIN/SEC countdown in the top bar — shares the SAME deadline as
     the offer-box "this offer expires" HH:MM:SS timer (aline_offer_deadline), same units */
  (function () {
    var box = document.querySelector('[data-ed-countdown]');
    if (!box) return;
    var hours = parseFloat(box.getAttribute('data-hours')) || 6;
    var KEY = 'aline_offer_deadline', now = Date.now();
    var dl = parseInt(localStorage.getItem(KEY), 10);
    if (!dl || isNaN(dl) || dl < now) { dl = now + hours * 3600000; try { localStorage.setItem(KEY, dl); } catch (e) {} }
    var elH = box.querySelector('[data-cd="h"]'), elM = box.querySelector('[data-cd="m"]'), elS = box.querySelector('[data-cd="s"]');
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    function tick() {
      var s = Math.max(0, Math.floor((dl - Date.now()) / 1000));
      if (elH) elH.textContent = pad(Math.floor(s / 3600));
      if (elM) elM.textContent = pad(Math.floor(s % 3600 / 60));
      if (elS) elS.textContent = pad(s % 60);
    }
    tick(); setInterval(tick, 1000);
  })();

  /* offer-box HH:MM:SS timer */
  (function () {
    var el = document.querySelector('[data-ed-timer]');
    if (!el) return;
    var hours = parseFloat(el.getAttribute('data-hours')) || 6, KEY = 'aline_offer_deadline', now = Date.now();
    var dl = parseInt(localStorage.getItem(KEY), 10);
    if (!dl || isNaN(dl) || dl < now) { dl = now + hours * 3600000; try { localStorage.setItem(KEY, dl); } catch (e) {} }
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var t = setInterval(function () { var s = Math.max(0, Math.floor((dl - Date.now()) / 1000)); el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60); if (s <= 0) clearInterval(t); }, 1000);
  })();

  /* testimonials peek carousel (mobile) */
  (function () {
    var mq = window.matchMedia('(max-width: 720px)');
    document.querySelectorAll('[data-ed-carousel]').forEach(function (track) {
      var dots = track.parentElement.querySelector('[data-ed-dots]');
      var cards = track.children; if (!dots || cards.length < 2) return;
      var idx = 0, timer = null;
      for (var i = 0; i < cards.length; i++) { var d = document.createElement('button'); d.type = 'button'; d.className = 'edlist__dot' + (i === 0 ? ' is-active' : ''); (function (n) { d.addEventListener('click', function () { go(n, true); }); })(i); dots.appendChild(d); }
      function setA(n) { for (var i = 0; i < dots.children.length; i++) dots.children[i].classList.toggle('is-active', i === n); }
      function go(n, u) { idx = (n + cards.length) % cards.length; var c = cards[idx]; track.scrollTo({ left: c.offsetLeft - (track.clientWidth - c.offsetWidth) / 2, behavior: 'smooth' }); setA(idx); if (u) restart(); }
      function next() { go(idx + 1, false); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function can() { return track.scrollWidth - track.clientWidth > 2; }
      function start() { stop(); if (can()) timer = setInterval(next, 4500); }
      function restart() { stop(); start(); }
      track.addEventListener('pointerdown', stop); track.addEventListener('pointerup', restart);
      if (mq.addEventListener) mq.addEventListener('change', restart);
      start();
    });
  })();

  /* Carry ad / UTM / click-id attribution from the landing URL onto every product CTA,
     so GA4 / Shopify / Meta see which ad (+ A/B variant + button) drove the product click. */
  (function () {
    var v = window.__edAB, params;
    try { params = new URLSearchParams(location.search); } catch (e) { params = null; }
    var CARRY = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'ad'];
    var extra = [];
    if (params) {
      CARRY.forEach(function (k) {
        var val = params.get(k);
        if (val) { val = val.replace(/[<>"']/g, '').slice(0, 200); if (val) extra.push([k, val]); }
      });
    }
    var links = document.querySelectorAll('a[href*="ref=sslistnew"]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href'); if (!href) continue;
      if ((v === 'a' || v === 'b') && href.indexOf('ab=') === -1) href += '&ab=' + v;
      for (var j = 0; j < extra.length; j++) {
        var k = extra[j][0];
        if (new RegExp('[?&]' + k + '=').test(href)) continue;
        href += '&' + k + '=' + encodeURIComponent(extra[j][1]);
      }
      links[i].setAttribute('href', href);
    }
  })();

  /* mobile sticky offer bar — reveal after scrolling past reason 1, dismissible for the session */
  (function () {
    var bar = document.querySelector('[data-ed-sticky]');
    if (!bar) return;
    if (window.matchMedia('(min-width:721px)').matches) return;
    try { if (sessionStorage.getItem('aline_sticky_closed') === '1') return; } catch (e) {}
    var first = document.querySelector('.edlist__reason');
    var closeBtn = bar.querySelector('[data-ed-sticky-close]');
    if (closeBtn) closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      bar.classList.remove('is-visible');
      try { sessionStorage.setItem('aline_sticky_closed', '1'); } catch (e2) {}
    });
    var shown = false;
    function check() {
      if (shown) return;
      var past = first ? (first.getBoundingClientRect().bottom < window.innerHeight * 0.5) : (window.pageYOffset > 700);
      if (past) { shown = true; bar.classList.add('is-visible'); window.removeEventListener('scroll', check); }
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aline-listicle-finalboss"]) return;
  try {
    
  /* ticking HRS/MIN/SEC countdown in the top bar — shares the SAME deadline as
     the offer-box "this offer expires" HH:MM:SS timer (aline_offer_deadline) */
  (function () {
    var box = document.querySelector('[data-fb-countdown]');
    if (!box) return;
    var hours = parseFloat(box.getAttribute('data-hours')) || 5;
    var KEY = 'aline_offer_deadline', now = Date.now();
    var dl = parseInt(localStorage.getItem(KEY), 10);
    if (!dl || isNaN(dl) || dl < now) { dl = now + hours * 3600000; try { localStorage.setItem(KEY, dl); } catch (e) {} }
    var elH = box.querySelector('[data-cd="h"]'), elM = box.querySelector('[data-cd="m"]'), elS = box.querySelector('[data-cd="s"]');
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    function tick() {
      var s = Math.max(0, Math.floor((dl - Date.now()) / 1000));
      if (elH) elH.textContent = pad(Math.floor(s / 3600));
      if (elM) elM.textContent = pad(Math.floor(s % 3600 / 60));
      if (elS) elS.textContent = pad(s % 60);
    }
    tick(); setInterval(tick, 1000);
  })();

  /* offer-box HH:MM:SS timer */
  (function () {
    var el = document.querySelector('[data-fb-timer]');
    if (!el) return;
    var hours = parseFloat(el.getAttribute('data-hours')) || 5, KEY = 'aline_offer_deadline', now = Date.now();
    var dl = parseInt(localStorage.getItem(KEY), 10);
    if (!dl || isNaN(dl) || dl < now) { dl = now + hours * 3600000; try { localStorage.setItem(KEY, dl); } catch (e) {} }
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var t = setInterval(function () { var s = Math.max(0, Math.floor((dl - Date.now()) / 1000)); el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60); if (s <= 0) clearInterval(t); }, 1000);
  })();

  /* testimonials peek carousel (mobile) */
  (function () {
    var mq = window.matchMedia('(max-width: 720px)');
    document.querySelectorAll('[data-fb-carousel]').forEach(function (track) {
      var dots = track.parentElement.querySelector('[data-fb-dots]');
      var reals = Array.prototype.slice.call(track.children);
      var n = reals.length;
      if (n < 2) { if (dots) dots.style.display = 'none'; return; }

      /* Clone the whole set before and after the originals and start on the middle
         set. When a scroll settles inside a clone we rebase by exactly one set
         width onto identical content, so the loop never hits an edge. */
      function cloneSet(where) {
        var frag = document.createDocumentFragment();
        reals.forEach(function (c) {
          var k = c.cloneNode(true);
          k.setAttribute('data-clone', '');
          k.setAttribute('aria-hidden', 'true');
          frag.appendChild(k);
        });
        if (where === 'before') track.insertBefore(frag, reals[0]);
        else track.appendChild(frag);
      }
      cloneSet('before');
      cloneSet('after');

      function step() {
        var a = track.children[0].getBoundingClientRect();
        var b = track.children[1].getBoundingClientRect();
        return Math.round(b.left - a.left) || Math.round(a.width);
      }
      function setWidth() { return step() * n; }
      function home() { track.scrollLeft = setWidth(); }
      requestAnimationFrame(home);
      window.addEventListener('resize', function () { requestAnimationFrame(home); });

      if (dots) {
        reals.forEach(function (_, i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'edlist__dot' + (i === 0 ? ' is-active' : '');
          d.setAttribute('aria-label', 'Testimonial ' + (i + 1));
          d.addEventListener('click', function () {
            track.scrollTo({ left: setWidth() + i * step(), behavior: 'smooth' });
          });
          dots.appendChild(d);
        });
      }

      /* scroll-snap: mandatory reverts a scrollLeft written while it is active,
         so switch it off for the moment of the jump. */
      function settle() {
        var w = setWidth();
        if (w) {
          var delta = 0;
          if (track.scrollLeft < w * 0.5) delta = w;
          else if (track.scrollLeft > w * 1.5) delta = -w;
          if (delta) {
            var prev = track.style.scrollSnapType;
            track.style.scrollSnapType = 'none';
            track.scrollLeft += delta;
            setTimeout(function () { track.style.scrollSnapType = prev; }, 60);
          }
        }
        paint();
      }

      /* paint on every scroll frame so the active dot tracks the cards instead
         of jumping 90ms after they land */
      var seen = -1;
      function paint() {
        if (!dots || !dots.children.length) return;
        var i = Math.round((track.scrollLeft - setWidth()) / (step() || 1));
        i = ((i % n) + n) % n;
        if (i === seen) return;
        seen = i;
        Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-active', k === i); });
      }

      var t, raf;
      track.addEventListener('scroll', function () {
        if (!raf) raf = requestAnimationFrame(function () { raf = null; paint(); });
        clearTimeout(t);
        t = setTimeout(settle, 90);
      }, { passive: true });

      /* Manual only — the visitor clicks through. The clone sets mean the arrows
         never dead-end, so prev from the first card lands on the last. */
      var wrap = track.parentElement;
      var prev = wrap.querySelector('[data-fb-prev]');
      var next = wrap.querySelector('[data-fb-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  })();

  /* Carry ad / UTM / click-id attribution from the landing URL onto every product CTA */
  (function () {
    var v = window.__fbAB, params;
    try { params = new URLSearchParams(location.search); } catch (e) { params = null; }
    var CARRY = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'ad'];
    var extra = [];
    if (params) {
      CARRY.forEach(function (k) {
        var val = params.get(k);
        if (val) { val = val.replace(/[<>"']/g, '').slice(0, 200); if (val) extra.push([k, val]); }
      });
    }
    var links = document.querySelectorAll('a[href*="ref=sslistfb"]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href'); if (!href) continue;
      if ((v === 'a' || v === 'b') && href.indexOf('ab=') === -1) href += '&ab=' + v;
      for (var j = 0; j < extra.length; j++) {
        var k = extra[j][0];
        if (new RegExp('[?&]' + k + '=').test(href)) continue;
        href += '&' + k + '=' + encodeURIComponent(extra[j][1]);
      }
      links[i].setAttribute('href', href);
    }
  })();

  /* mobile sticky offer bar — reveal after scrolling past reason 1, dismissible for the session */
  (function () {
    var bar = document.querySelector('[data-fb-sticky]');
    if (!bar) return;
    if (window.matchMedia('(min-width:721px)').matches) return;
    try { if (sessionStorage.getItem('aline_sticky_closed') === '1') return; } catch (e) {}
    var first = document.querySelector('.edlist__reason');
    var closeBtn = bar.querySelector('[data-fb-sticky-close]');
    if (closeBtn) closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      bar.classList.remove('is-visible');
      try { sessionStorage.setItem('aline_sticky_closed', '1'); } catch (e2) {}
    });
    var shown = false;
    function check() {
      if (shown) return;
      var past = first ? (first.getBoundingClientRect().bottom < window.innerHeight * 0.5) : (window.pageYOffset > 700);
      if (past) { shown = true; bar.classList.add('is-visible'); window.removeEventListener('scroll', check); }
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aline-listicle-meno"]) return;
  try {
    
  /* ticking HRS/MIN/SEC countdown in the top bar — shares the SAME deadline as
     the offer-box "this offer expires" HH:MM:SS timer (aline_offer_deadline) */
  (function () {
    var box = document.querySelector('[data-ed-countdown]');
    if (!box) return;
    var hours = parseFloat(box.getAttribute('data-hours')) || 5;
    var KEY = 'aline_offer_deadline', now = Date.now();
    var dl = parseInt(localStorage.getItem(KEY), 10);
    if (!dl || isNaN(dl) || dl < now) { dl = now + hours * 3600000; try { localStorage.setItem(KEY, dl); } catch (e) {} }
    var elH = box.querySelector('[data-cd="h"]'), elM = box.querySelector('[data-cd="m"]'), elS = box.querySelector('[data-cd="s"]');
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    function tick() {
      var s = Math.max(0, Math.floor((dl - Date.now()) / 1000));
      if (elH) elH.textContent = pad(Math.floor(s / 3600));
      if (elM) elM.textContent = pad(Math.floor(s % 3600 / 60));
      if (elS) elS.textContent = pad(s % 60);
    }
    tick(); setInterval(tick, 1000);
  })();

  /* offer-box HH:MM:SS timer */
  (function () {
    var el = document.querySelector('[data-ed-timer]');
    if (!el) return;
    var hours = parseFloat(el.getAttribute('data-hours')) || 5, KEY = 'aline_offer_deadline', now = Date.now();
    var dl = parseInt(localStorage.getItem(KEY), 10);
    if (!dl || isNaN(dl) || dl < now) { dl = now + hours * 3600000; try { localStorage.setItem(KEY, dl); } catch (e) {} }
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var t = setInterval(function () { var s = Math.max(0, Math.floor((dl - Date.now()) / 1000)); el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60); if (s <= 0) clearInterval(t); }, 1000);
  })();

  /* testimonials peek carousel (mobile) */
  (function () {
    var mq = window.matchMedia('(max-width: 720px)');
    document.querySelectorAll('[data-ed-carousel]').forEach(function (track) {
      var dots = track.parentElement.querySelector('[data-ed-dots]');
      var cards = track.children; if (!dots || cards.length < 2) return;
      var idx = 0, timer = null;
      for (var i = 0; i < cards.length; i++) { var d = document.createElement('button'); d.type = 'button'; d.className = 'edlist__dot' + (i === 0 ? ' is-active' : ''); (function (n) { d.addEventListener('click', function () { go(n, true); }); })(i); dots.appendChild(d); }
      function setA(n) { for (var i = 0; i < dots.children.length; i++) dots.children[i].classList.toggle('is-active', i === n); }
      function go(n, u) { idx = (n + cards.length) % cards.length; var c = cards[idx]; track.scrollTo({ left: c.offsetLeft - (track.clientWidth - c.offsetWidth) / 2, behavior: 'smooth' }); setA(idx); if (u) restart(); }
      function next() { go(idx + 1, false); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function can() { return track.scrollWidth - track.clientWidth > 2; }
      function start() { stop(); if (can()) timer = setInterval(next, 4500); }
      function restart() { stop(); start(); }
      track.addEventListener('pointerdown', stop); track.addEventListener('pointerup', restart);
      if (mq.addEventListener) mq.addEventListener('change', restart);
      start();
    });
  })();

  /* Carry ad / UTM / click-id attribution from the landing URL onto every product CTA */
  (function () {
    var v = window.__menoAB, params;
    try { params = new URLSearchParams(location.search); } catch (e) { params = null; }
    var CARRY = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'ad'];
    var extra = [];
    if (params) {
      CARRY.forEach(function (k) {
        var val = params.get(k);
        if (val) { val = val.replace(/[<>"']/g, '').slice(0, 200); if (val) extra.push([k, val]); }
      });
    }
    var links = document.querySelectorAll('a[href*="ref=menoss"]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href'); if (!href) continue;
      if ((v === 'a' || v === 'b') && href.indexOf('ab=') === -1) href += '&ab=' + v;
      for (var j = 0; j < extra.length; j++) {
        var k = extra[j][0];
        if (new RegExp('[?&]' + k + '=').test(href)) continue;
        href += '&' + k + '=' + encodeURIComponent(extra[j][1]);
      }
      links[i].setAttribute('href', href);
    }
  })();

  /* mobile sticky offer bar — reveal after scrolling past reason 1, dismissible for the session */
  (function () {
    var bar = document.querySelector('[data-ed-sticky]');
    if (!bar) return;
    if (window.matchMedia('(min-width:721px)').matches) return;
    try { if (sessionStorage.getItem('aline_sticky_closed') === '1') return; } catch (e) {}
    var first = document.querySelector('.edlist__reason');
    var closeBtn = bar.querySelector('[data-ed-sticky-close]');
    if (closeBtn) closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      bar.classList.remove('is-visible');
      try { sessionStorage.setItem('aline_sticky_closed', '1'); } catch (e2) {}
    });
    var shown = false;
    function check() {
      if (shown) return;
      var past = first ? (first.getBoundingClientRect().bottom < window.innerHeight * 0.5) : (window.pageYOffset > 700);
      if (past) { shown = true; bar.classList.add('is-visible'); window.removeEventListener('scroll', check); }
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aline-listicle-sidesleep-editorial"]) return;
  try {
    
  /* ticking HRS/MIN/SEC countdown in the top bar — shares the SAME deadline as
     the offer-box "this offer expires" HH:MM:SS timer (aline_offer_deadline), same units */
  (function () {
    var box = document.querySelector('[data-ed-countdown]');
    if (!box) return;
    var hours = parseFloat(box.getAttribute('data-hours')) || 5;
    var KEY = 'aline_offer_deadline', now = Date.now();
    var dl = parseInt(localStorage.getItem(KEY), 10);
    if (!dl || isNaN(dl) || dl < now) { dl = now + hours * 3600000; try { localStorage.setItem(KEY, dl); } catch (e) {} }
    var elH = box.querySelector('[data-cd="h"]'), elM = box.querySelector('[data-cd="m"]'), elS = box.querySelector('[data-cd="s"]');
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    function tick() {
      var s = Math.max(0, Math.floor((dl - Date.now()) / 1000));
      if (elH) elH.textContent = pad(Math.floor(s / 3600));
      if (elM) elM.textContent = pad(Math.floor(s % 3600 / 60));
      if (elS) elS.textContent = pad(s % 60);
    }
    tick(); setInterval(tick, 1000);
  })();

  /* offer-box HH:MM:SS timer */
  (function () {
    var el = document.querySelector('[data-ed-timer]');
    if (!el) return;
    var hours = parseFloat(el.getAttribute('data-hours')) || 5, KEY = 'aline_offer_deadline', now = Date.now();
    var dl = parseInt(localStorage.getItem(KEY), 10);
    if (!dl || isNaN(dl) || dl < now) { dl = now + hours * 3600000; try { localStorage.setItem(KEY, dl); } catch (e) {} }
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var t = setInterval(function () { var s = Math.max(0, Math.floor((dl - Date.now()) / 1000)); el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60); if (s <= 0) clearInterval(t); }, 1000);
  })();

  /* FAQ accordion */
  (function () {
    document.querySelectorAll('[data-ed-acc]').forEach(function (item) {
      var btn = item.querySelector('.edlist__faq-q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  })();

  /* testimonials peek carousel (mobile) */
  (function () {
    var mq = window.matchMedia('(max-width: 720px)');
    document.querySelectorAll('[data-ed-carousel]').forEach(function (track) {
      var dots = track.parentElement.querySelector('[data-ed-dots]');
      var cards = track.children; if (!dots || cards.length < 2) return;
      var idx = 0, timer = null;
      for (var i = 0; i < cards.length; i++) { var d = document.createElement('button'); d.type = 'button'; d.className = 'edlist__dot' + (i === 0 ? ' is-active' : ''); (function (n) { d.addEventListener('click', function () { go(n, true); }); })(i); dots.appendChild(d); }
      function setA(n) { for (var i = 0; i < dots.children.length; i++) dots.children[i].classList.toggle('is-active', i === n); }
      function go(n, u) { idx = (n + cards.length) % cards.length; var c = cards[idx]; track.scrollTo({ left: c.offsetLeft - (track.clientWidth - c.offsetWidth) / 2, behavior: 'smooth' }); setA(idx); if (u) restart(); }
      function next() { go(idx + 1, false); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function can() { return track.scrollWidth - track.clientWidth > 2; }
      function start() { stop(); if (can()) timer = setInterval(next, 4500); }
      function restart() { stop(); start(); }
      track.addEventListener('pointerdown', stop); track.addEventListener('pointerup', restart);
      if (mq.addEventListener) mq.addEventListener('change', restart);
      start();
    });
  })();

  /* Carry ad / UTM / click-id attribution from the landing URL onto every product CTA,
     so GA4 / Shopify / Meta see which ad (+ A/B variant + button) drove the product click. */
  (function () {
    var v = window.__ssAB, params;
    try { params = new URLSearchParams(location.search); } catch (e) { params = null; }
    var CARRY = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'ad'];
    var extra = [];
    if (params) {
      CARRY.forEach(function (k) {
        var val = params.get(k);
        if (val) { val = val.replace(/[<>"']/g, '').slice(0, 200); if (val) extra.push([k, val]); }
      });
    }
    var links = document.querySelectorAll('a[href*="ref=sslisticle"]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href'); if (!href) continue;
      if ((v === 'a' || v === 'b') && href.indexOf('ab=') === -1) href += '&ab=' + v;
      for (var j = 0; j < extra.length; j++) {
        var k = extra[j][0];
        if (new RegExp('[?&]' + k + '=').test(href)) continue;
        href += '&' + k + '=' + encodeURIComponent(extra[j][1]);
      }
      links[i].setAttribute('href', href);
    }
  })();

  /* mobile sticky offer bar — reveal after scrolling past reason 1, dismissible for the session */
  (function () {
    var bar = document.querySelector('[data-ed-sticky]');
    if (!bar) return;
    if (window.matchMedia('(min-width:721px)').matches) return;
    try { if (sessionStorage.getItem('aline_sticky_closed') === '1') return; } catch (e) {}
    var first = document.querySelector('.edlist__reason');
    var closeBtn = bar.querySelector('[data-ed-sticky-close]');
    if (closeBtn) closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      bar.classList.remove('is-visible');
      try { sessionStorage.setItem('aline_sticky_closed', '1'); } catch (e2) {}
    });
    var shown = false;
    function check() {
      if (shown) return;
      var past = first ? (first.getBoundingClientRect().bottom < window.innerHeight * 0.5) : (window.pageYOffset > 700);
      if (past) { shown = true; bar.classList.add('is-visible'); window.removeEventListener('scroll', check); }
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aline-listicle-sidesleep-v2"]) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-countdown]');
    if (!el) return;
    var hours = parseFloat(el.getAttribute('data-hours')) || 5;
    var KEY = 'aline_offer_deadline';
    var now = Date.now();
    var deadline = parseInt(localStorage.getItem(KEY), 10);
    if (!deadline || isNaN(deadline) || deadline < now) {
      deadline = now + hours * 3600 * 1000;
      try { localStorage.setItem(KEY, deadline); } catch (e) {}
    }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var s = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
      el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      if (s <= 0) clearInterval(timer);
    }
    tick();
    var timer = setInterval(tick, 1000);
  })();

  (function () {
    var mq = window.matchMedia('(max-width: 760px)');
    var tracks = document.querySelectorAll('[data-carousel]');
    for (var t = 0; t < tracks.length; t++) initCarousel(tracks[t]);
    function initCarousel(track) {
      var dotsWrap = track.parentElement.querySelector('[data-carousel-dots]');
      var cards = track.children;
      if (!dotsWrap || cards.length < 2) return;
      var idx = 0, timer = null, st = null;
      for (var i = 0; i < cards.length; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'mcar-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Show slide ' + (i + 1));
        (function (n) { dot.addEventListener('click', function () { goTo(n, true); }); })(i);
        dotsWrap.appendChild(dot);
      }
      var dots = dotsWrap.children;
      function setActive(n) { for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === n); }
      function goTo(n, user) {
        idx = (n + cards.length) % cards.length;
        var left = cards[idx].offsetLeft - (track.clientWidth - cards[idx].offsetWidth) / 2;
        track.scrollTo({ left: left < 0 ? 0 : left, behavior: 'smooth' });
        setActive(idx);
        if (user) restart();
      }
      function next() { goTo(idx + 1, false); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      // Autoplay whenever the track actually overflows (true on mobile AND on the
      // desktop testimonials peek-slider) — no longer gated to mobile only.
      function canScroll() { return track.scrollWidth - track.clientWidth > 2; }
      function start() { stop(); if (canScroll()) timer = setInterval(next, 4500); }
      function restart() { stop(); start(); }
      track.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () {
          var center = track.scrollLeft + track.clientWidth / 2, best = 0, bestDist = Infinity;
          for (var k = 0; k < cards.length; k++) {
            var cc = cards[k].offsetLeft + cards[k].offsetWidth / 2, d = Math.abs(cc - center);
            if (d < bestDist) { bestDist = d; best = k; }
          }
          if (best !== idx) { idx = best; setActive(idx); }
        }, 90);
      }, { passive: true });
      track.addEventListener('pointerdown', stop);
      track.addEventListener('pointerup', restart);
      if (mq.addEventListener) mq.addEventListener('change', restart); else if (mq.addListener) mq.addListener(restart);
      start();
    }
  })();

  (function () {
    var v = window.__alineAB;
    if (v !== 'a' && v !== 'b') return;
    var links = document.querySelectorAll('a[href*="ref=sslisticle"]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href');
      if (href && href.indexOf('ab=') === -1) links[i].setAttribute('href', href + '&ab=' + v);
    }
  })();

  (function () {
    // Ad-source passthrough: an ad links here with ?ad=<name> (native/video/short/…);
    // carry it onto every product CTA so GA4 can attribute product clicks to that ad.
    try {
      var ad = new URLSearchParams(location.search).get('ad');
      if (!ad) return;
      ad = ad.replace(/[^a-z0-9_-]/gi, '').slice(0, 32);
      if (!ad) return;
      var links = document.querySelectorAll('a[href*="ref=sslisticle"]');
      for (var i = 0; i < links.length; i++) {
        var href = links[i].getAttribute('href');
        if (href && !/[?&]ad=/.test(href)) links[i].setAttribute('href', href + '&ad=' + ad);
      }
    } catch (e) {}
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aline-listicle-sidesleep-v3"]) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-countdown]');
    if (!el) return;
    var hours = parseFloat(el.getAttribute('data-hours')) || 5;
    var KEY = 'aline_offer_deadline';
    var now = Date.now();
    var deadline = parseInt(localStorage.getItem(KEY), 10);
    if (!deadline || isNaN(deadline) || deadline < now) {
      deadline = now + hours * 3600 * 1000;
      try { localStorage.setItem(KEY, deadline); } catch (e) {}
    }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var s = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
      el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      if (s <= 0) clearInterval(timer);
    }
    tick();
    var timer = setInterval(tick, 1000);
  })();

  (function () {
    var mq = window.matchMedia('(max-width: 760px)');
    var tracks = document.querySelectorAll('[data-carousel]');
    for (var t = 0; t < tracks.length; t++) initCarousel(tracks[t]);
    function initCarousel(track) {
      var dotsWrap = track.parentElement.querySelector('[data-carousel-dots]');
      var cards = track.children;
      if (!dotsWrap || cards.length < 2) return;
      var idx = 0, timer = null, st = null;
      for (var i = 0; i < cards.length; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'mcar-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Show slide ' + (i + 1));
        (function (n) { dot.addEventListener('click', function () { goTo(n, true); }); })(i);
        dotsWrap.appendChild(dot);
      }
      var dots = dotsWrap.children;
      function setActive(n) { for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === n); }
      function goTo(n, user) {
        idx = (n + cards.length) % cards.length;
        var left = cards[idx].offsetLeft - (track.clientWidth - cards[idx].offsetWidth) / 2;
        track.scrollTo({ left: left < 0 ? 0 : left, behavior: 'smooth' });
        setActive(idx);
        if (user) restart();
      }
      function next() { goTo(idx + 1, false); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      // Autoplay whenever the track actually overflows (true on mobile AND on the
      // desktop testimonials peek-slider) — no longer gated to mobile only.
      function canScroll() { return track.scrollWidth - track.clientWidth > 2; }
      function start() { stop(); if (canScroll()) timer = setInterval(next, 4500); }
      function restart() { stop(); start(); }
      track.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () {
          var center = track.scrollLeft + track.clientWidth / 2, best = 0, bestDist = Infinity;
          for (var k = 0; k < cards.length; k++) {
            var cc = cards[k].offsetLeft + cards[k].offsetWidth / 2, d = Math.abs(cc - center);
            if (d < bestDist) { bestDist = d; best = k; }
          }
          if (best !== idx) { idx = best; setActive(idx); }
        }, 90);
      }, { passive: true });
      track.addEventListener('pointerdown', stop);
      track.addEventListener('pointerup', restart);
      if (mq.addEventListener) mq.addEventListener('change', restart); else if (mq.addListener) mq.addListener(restart);
      start();
    }
  })();

  (function () {
    var v = window.__alineAB;
    if (v !== 'a' && v !== 'b') return;
    var links = document.querySelectorAll('a[href*="ref=sslisticle"]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href');
      if (href && href.indexOf('ab=') === -1) links[i].setAttribute('href', href + '&ab=' + v);
    }
  })();

  (function () {
    // Ad-source passthrough: an ad links here with ?ad=<name> (native/video/short/…);
    // carry it onto every product CTA so GA4 can attribute product clicks to that ad.
    try {
      var ad = new URLSearchParams(location.search).get('ad');
      if (!ad) return;
      ad = ad.replace(/[^a-z0-9_-]/gi, '').slice(0, 32);
      if (!ad) return;
      var links = document.querySelectorAll('a[href*="ref=sslisticle"]');
      for (var i = 0; i < links.length; i++) {
        var href = links[i].getAttribute('href');
        if (href && !/[?&]ad=/.test(href)) links[i].setAttribute('href', href + '&ad=' + ad);
      }
    } catch (e) {}
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aline-listicle-v3"]) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-countdown]');
    if (!el) return;
    var hours = parseFloat(el.getAttribute('data-hours')) || 5;
    var KEY = 'aline_offer_deadline';
    var now = Date.now();
    var deadline = parseInt(localStorage.getItem(KEY), 10);
    if (!deadline || isNaN(deadline) || deadline < now) {
      deadline = now + hours * 3600 * 1000;
      try { localStorage.setItem(KEY, deadline); } catch (e) {}
    }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var s = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
      el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      if (s <= 0) clearInterval(timer);
    }
    tick();
    var timer = setInterval(tick, 1000);
  })();

  (function () {
    var mq = window.matchMedia('(max-width: 760px)');
    var tracks = document.querySelectorAll('[data-carousel]');
    for (var t = 0; t < tracks.length; t++) initCarousel(tracks[t]);
    function initCarousel(track) {
      var dotsWrap = track.parentElement.querySelector('[data-carousel-dots]');
      var cards = track.children;
      if (!dotsWrap || cards.length < 2) return;
      var idx = 0, timer = null, st = null;
      for (var i = 0; i < cards.length; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'mcar-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Show slide ' + (i + 1));
        (function (n) { dot.addEventListener('click', function () { goTo(n, true); }); })(i);
        dotsWrap.appendChild(dot);
      }
      var dots = dotsWrap.children;
      function setActive(n) { for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === n); }
      function goTo(n, user) {
        idx = (n + cards.length) % cards.length;
        track.scrollTo({ left: cards[idx].offsetLeft, behavior: 'smooth' });
        setActive(idx);
        if (user) restart();
      }
      function next() { goTo(idx + 1, false); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() { stop(); if (mq.matches) timer = setInterval(next, 4500); }
      function restart() { stop(); start(); }
      track.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () {
          var w = cards[0].offsetWidth || 1;
          var i = Math.round(track.scrollLeft / w);
          i = Math.max(0, Math.min(cards.length - 1, i));
          if (i !== idx) { idx = i; setActive(idx); }
        }, 90);
      }, { passive: true });
      track.addEventListener('pointerdown', stop);
      track.addEventListener('pointerup', restart);
      if (mq.addEventListener) mq.addEventListener('change', restart); else if (mq.addListener) mq.addListener(restart);
      start();
    }
  })();

  (function () {
    var v = window.__alineAB;
    if (v !== 'a' && v !== 'b') return;
    var links = document.querySelectorAll('a[href*="ref=listicle"]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href');
      if (href && href.indexOf('ab=') === -1) links[i].setAttribute('href', href + '&ab=' + v);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aline-listicle"]) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-countdown]');
    if (!el) return;
    var hours = parseFloat(el.getAttribute('data-hours')) || 5;
    var KEY = 'aline_offer_deadline';
    var now = Date.now();
    var deadline = parseInt(localStorage.getItem(KEY), 10);
    if (!deadline || isNaN(deadline) || deadline < now) {
      deadline = now + hours * 3600 * 1000;
      try { localStorage.setItem(KEY, deadline); } catch (e) {}
    }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var s = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
      el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      if (s <= 0) clearInterval(timer);
    }
    tick();
    var timer = setInterval(tick, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aline-product"]) return;
  try {
    
  /* Colour-bundle offer box: pick a tier, choose a colour per pillow, add them all. */
  (function () {
    document.querySelectorAll('[data-bundle]').forEach(function (box) {
      var tiers = Array.prototype.slice.call(box.querySelectorAll('[data-tier]'));
      var addBtn = box.querySelector('[data-bundle-add]');
      var addPrice = box.querySelector('[data-add-price]');

      function selectTier(tier) {
        tiers.forEach(function (t) {
          var on = t === tier;
          t.classList.toggle('is-selected', on);
          var radio = t.querySelector('[data-tier-radio]');
          if (radio) radio.checked = on;
        });
        var p = tier.getAttribute('data-price');
        if (p && addPrice) addPrice.textContent = p;
      }

      tiers.forEach(function (t) {
        var radio = t.querySelector('[data-tier-radio]');
        if (radio) radio.addEventListener('change', function () { if (radio.checked) selectTier(t); });
        t.addEventListener('click', function (e) {
          if (e.target.closest('[data-color-group]')) return;
          selectTier(t);
        });
      });

      /* colour swatches — premium preview per pillow */
      box.querySelectorAll('[data-swatch]').forEach(function (sw) {
        sw.addEventListener('click', function () {
          if (sw.hasAttribute('disabled')) return;
          var group = sw.closest('[data-color-group]');
          if (!group) return;
          group.querySelectorAll('[data-swatch]').forEach(function (s) { s.classList.remove('is-selected'); });
          sw.classList.add('is-selected');
          var nameEl = group.querySelector('[data-color-name]');
          if (nameEl) nameEl.textContent = sw.getAttribute('data-variant-name');
          /* swap the main gallery image to this colour's photo (once variant images exist) */
          var imgUrl = sw.getAttribute('data-variant-image');
          var mainImg = document.querySelector('[data-gallery-main]');
          if (imgUrl && mainImg) { mainImg.removeAttribute('srcset'); mainImg.setAttribute('src', imgUrl); }
        });
      });

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var tier = box.querySelector('[data-tier].is-selected');
          if (!tier) return;
          var counts = {};
          tier.querySelectorAll('[data-color-group]').forEach(function (group) {
            var sw = group.querySelector('[data-swatch].is-selected') || group.querySelector('[data-swatch]:not([disabled])');
            if (sw) {
              var id = sw.getAttribute('data-variant-id');
              if (id) counts[id] = (counts[id] || 0) + 1;
            }
          });
          var items = Object.keys(counts).map(function (id) {
            return { id: parseInt(id, 10), quantity: counts[id] };
          });
          if (!items.length) return;
          var routes = window.alineRoutes || { cartAdd: '/cart/add', cart: '/cart' };
          addBtn.setAttribute('disabled', 'disabled');
          fetch(routes.cartAdd + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
            .then(function () {
              addBtn.removeAttribute('disabled');
              if (window.alineCart && window.alineCart.refresh) { window.alineCart.refresh().then(window.alineCart.open); }
              else { window.location.href = routes.cart; }
            })
            .catch(function () { addBtn.removeAttribute('disabled'); });
        });
      }
    });
  })();

  /* Guarantee seal shows only on the first/featured image, not on the other gallery shots */
  (function () {
    var mainImg = document.querySelector('[data-gallery-main]');
    var badges = document.querySelector('.pdp-seal');
    if (!mainImg || !badges) return;
    function fileOf(u) { return (u || '').split('?')[0].split('/').pop(); }
    var featured = fileOf(mainImg.getAttribute('src'));
    function upd() { badges.style.display = (fileOf(mainImg.getAttribute('src')) === featured) ? '' : 'none'; }
    new MutationObserver(upd).observe(mainImg, { attributes: true, attributeFilter: ['src'] });
    upd();
  })();

  /* Mobile sticky offer bar — shows once the real add-to-cart has scrolled out of view,
     hides again when it's back on screen (so it never covers the actual button).
     Dismissible for the session. CSS keeps it hidden entirely above 989px. */
  (function () {
    var bar = document.querySelector('[data-pdp-sticky]');
    if (!bar) return;
    var addBtn = document.querySelector('[data-bundle-add]');
    var form = document.querySelector('.pdp__form');
    if (!addBtn || !form) return;
    var dismissed = false;
    try { dismissed = sessionStorage.getItem('aline_pdp_sticky_closed') === '1'; } catch (e) {}
    if (dismissed) return;

    var closeBtn = bar.querySelector('[data-pdp-sticky-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () {
      dismissed = true;
      bar.classList.remove('is-visible');
      try { sessionStorage.setItem('aline_pdp_sticky_closed', '1'); } catch (e) {}
    });

    var cta = bar.querySelector('[data-pdp-sticky-cta]');
    if (cta) cta.addEventListener('click', function () {
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    function check() {
      if (dismissed) return;
      // reveal only after the real add-to-cart button has scrolled above the viewport
      bar.classList.toggle('is-visible', addBtn.getBoundingClientRect().bottom < 0);
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
  })();

  /* Rating at the top jumps down to the Customer Reviews section.
     If this template has no reviews section, fall back to plain text. */
  (function () {
    var link = document.querySelector('[data-pdp-rating-link]');
    if (!link) return;
    var target = document.querySelector('#customer-reviews');
    if (!target) {
      link.classList.add('is-static');
      link.removeAttribute('href');
      return;
    }
    link.addEventListener('click', function (e) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', '#customer-reviews');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aline-reviews"] && !Shopify.designMode) return;
  try {
    
  /* Featured reviews carousel: native scroll-snap (so mobile swiping stays effortless),
     driven by arrows on desktop and dots on mobile.

     Infinite loop: the full set of cards is cloned once before and once after the
     originals, and the track starts on the middle set. When a scroll settles inside
     a clone set we jump back by exactly one set width — same pixel offset, identical
     content, so the seam is invisible. Cloning a whole set (rather than one card)
     is what makes it seamless at the 3-up desktop size, where several cards are
     visible at once. */
  (function () {
    document.querySelectorAll('[data-rev-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-rev-track]');
      var reals = Array.prototype.slice.call(root.querySelectorAll('[data-rev-card]'));
      var prev = root.querySelector('[data-rev-prev]');
      var next = root.querySelector('[data-rev-next]');
      var dotsWrap = root.querySelector('[data-rev-dots]');
      var n = reals.length;
      if (!track || n < 2) {
        if (prev) prev.style.display = 'none';
        if (next) next.style.display = 'none';
        if (dotsWrap) dotsWrap.style.display = 'none';
        return;
      }

      var frag = document.createDocumentFragment();
      reals.forEach(function (c) {
        var b = c.cloneNode(true);
        b.setAttribute('data-clone', ''); b.setAttribute('aria-hidden', 'true');
        b.removeAttribute('data-rev-card');
        frag.appendChild(b);
      });
      track.insertBefore(frag, reals[0]);
      reals.forEach(function (c) {
        var a = c.cloneNode(true);
        a.setAttribute('data-clone', ''); a.setAttribute('aria-hidden', 'true');
        a.removeAttribute('data-rev-card');
        track.appendChild(a);
      });

      function stepSize() {
        var all = track.children;
        if (all.length < 2) return Math.round(all[0].getBoundingClientRect().width);
        return Math.round(all[1].getBoundingClientRect().left - all[0].getBoundingClientRect().left);
      }
      function setWidth() { return stepSize() * n; }
      function home() { track.scrollLeft = setWidth(); }

      requestAnimationFrame(home);
      window.addEventListener('resize', function () { requestAnimationFrame(home); });

      cardsDots();
      function cardsDots() {
        reals.forEach(function (_, i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'reviews__dot' + (i === 0 ? ' is-active' : '');
          d.setAttribute('aria-label', 'Review ' + (i + 1));
          d.addEventListener('click', function () {
            track.scrollTo({ left: setWidth() + i * stepSize(), behavior: 'smooth' });
          });
          dotsWrap.appendChild(d);
        });
      }
      var dots = Array.prototype.slice.call(dotsWrap.children);

      /* Mobile uses scroll-snap: x mandatory, and the snap engine reverts a scrollLeft
         written while it is active — so the loop silently failed to rebase there.
         Switching snapping off for the one frame the jump happens in fixes it. */
      function jump(delta) {
        var prevSnap = track.style.scrollSnapType;
        track.style.scrollSnapType = 'none';
        track.scrollLeft += delta;
        /* One frame is not always enough for the new position to stick before the
           snap engine comes back — a short timeout is reliable on iOS and Chrome. */
        setTimeout(function () { track.style.scrollSnapType = prevSnap; }, 60);
      }

      function sync() {
        var w = setWidth();
        if (w > 0) {
          /* Settled inside a clone set — rebase to the identical position one set over. */
          if (track.scrollLeft < w * 0.5) jump(w);
          else if (track.scrollLeft > w * 1.5) jump(-w);
        }
        var step = stepSize() || 1;
        var i = Math.round((track.scrollLeft - w) / step);
        i = ((i % n) + n) % n;
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -stepSize(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: stepSize(), behavior: 'smooth' }); });

      var t;
      track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 90); }, { passive: true });
      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aline-social-proof"] && !Shopify.designMode) return;
  try {
    
  /* Photo strip: arrows on desktop, swipe on mobile, and an infinite loop in both.

     The whole set of photos is cloned once before and once after the originals and
     the track starts on the middle set; when a scroll settles inside a clone set we
     rebase by exactly one set width onto identical content, so the seam is invisible.
     A single leading/trailing clone is not enough here — desktop shows about three
     cards at once, so the wrap has to survive a viewport that spans several slides. */
  (function () {
    document.querySelectorAll('[data-spf-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-spf-track]');
      var prev = root.querySelector('[data-spf-prev]');
      var next = root.querySelector('[data-spf-next]');
      if (!track) return;
      var reals = Array.prototype.slice.call(track.children);
      var n = reals.length;
      if (n < 2) {
        if (prev) prev.style.display = 'none';
        if (next) next.style.display = 'none';
        return;
      }

      function cloneSet(where) {
        var frag = document.createDocumentFragment();
        reals.forEach(function (c) {
          var k = c.cloneNode(true);
          k.setAttribute('data-clone', '');
          k.setAttribute('aria-hidden', 'true');
          frag.appendChild(k);
        });
        if (where === 'before') track.insertBefore(frag, reals[0]);
        else track.appendChild(frag);
      }
      cloneSet('before');
      cloneSet('after');

      function step() {
        var a = track.children[0].getBoundingClientRect();
        var b = track.children[1].getBoundingClientRect();
        return Math.round(b.left - a.left) || Math.round(a.width);
      }
      function setWidth() { return step() * n; }
      function home() { track.scrollLeft = setWidth(); }

      requestAnimationFrame(home);
      window.addEventListener('resize', function () { requestAnimationFrame(home); });

      /* scroll-snap: mandatory reverts a scrollLeft written while it is active,
         so it is switched off for the moment of the jump. */
      function rebase() {
        var w = setWidth();
        if (!w) return;
        var delta = 0;
        if (track.scrollLeft < w * 0.5) delta = w;
        else if (track.scrollLeft > w * 1.5) delta = -w;
        if (!delta) return;
        var prevSnap = track.style.scrollSnapType;
        track.style.scrollSnapType = 'none';
        track.scrollLeft += delta;
        setTimeout(function () { track.style.scrollSnapType = prevSnap; }, 60);
      }

      var settle;
      track.addEventListener('scroll', function () {
        clearTimeout(settle);
        settle = setTimeout(rebase, 90);
      }, { passive: true });

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      /* Manual only — no autoplay anywhere on the site. */
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aline-uv-main"]) return;
  try {
    
  /* Gallery rail, tier switching and the FAQ for the Uvola-style product page. */
  (function () {
    /* ---- gallery ---- */
    var rail = document.querySelector('[data-uv-gal]');
    if (rail) {
      var strip = document.querySelector('[data-uv-gal-thumbs]');
      var thumbs = strip ? Array.prototype.slice.call(strip.querySelectorAll('[data-uv-gal-thumb]')) : [];
      var slides = Array.prototype.slice.call(rail.children);
      var dots = document.querySelector('[data-uv-gal-dots]');

      /* Mobile pager: dots mirroring the filmstrip, tappable. */
      if (dots) {
        slides.forEach(function (_, i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'uv__dot' + (i === 0 ? ' is-on' : '');
          d.setAttribute('aria-label', 'Image ' + (i + 1));
          d.addEventListener('click', function () { rail.scrollTo({ left: i * step(), behavior: 'smooth' }); });
          dots.appendChild(d);
        });
      }

      /* The three benefit tiles ride inside the first slide on mobile so they
         scroll away with it, and return to their own column on desktop. */
      var gal = rail.closest('.uv-gal');
      var unit = rail.querySelector('.uv-gal__unit');
      var perks = gal ? gal.querySelector('.uv-gal__perks') : null;
      var foot = gal ? gal.querySelector('.uv-gal__foot') : null;
      if (perks && unit) {
        var narrow = window.matchMedia('(max-width:899px)');
        var placePerks = function () {
          if (narrow.matches) { if (perks.parentElement !== unit) unit.appendChild(perks); }
          else if (perks.parentElement !== gal) gal.insertBefore(perks, foot);
        };
        placePerks();
        if (narrow.addEventListener) narrow.addEventListener('change', placePerks);
        else narrow.addListener(placePerks);
      }
      function step() {
        var a = slides[0].getBoundingClientRect();
        var b = slides[1] ? slides[1].getBoundingClientRect() : null;
        return b ? Math.round(b.left - a.left) : Math.round(a.width);
      }
      thumbs.forEach(function (btn, i) {
        btn.addEventListener('click', function () { rail.scrollTo({ left: i * step(), behavior: 'smooth' }); });
      });
      /* keep the highlighted thumbnail in step with the rail, and drag it into
         view when the visitor pages past the end of the strip */
      var seen = -1, raf;
      function sync() {
        if (!thumbs.length && !dots) return;
        var i = Math.round(rail.scrollLeft / (step() || 1));
        if (i < 0) i = 0;
        if (i > thumbs.length - 1) i = thumbs.length - 1;
        if (i === seen) return;
        seen = i;
        thumbs.forEach(function (b, n) { b.classList.toggle('is-on', n === i); });
        if (dots) Array.prototype.forEach.call(dots.children, function (d, n) { d.classList.toggle('is-on', n === i); });
        var t = thumbs[i];
        if (!t || !strip.offsetParent) return;   /* filmstrip is hidden on mobile */
        var sr = strip.getBoundingClientRect(), tr = t.getBoundingClientRect();
        if (tr.left < sr.left) strip.scrollLeft += tr.left - sr.left - 10;
        else if (tr.right > sr.right) strip.scrollLeft += tr.right - sr.right + 10;
      }
      rail.addEventListener('scroll', function () {
        if (!raf) raf = requestAnimationFrame(function () { raf = null; sync(); });
      }, { passive: true });
      var prev = document.querySelector('[data-uv-gal-prev]');
      var next = document.querySelector('[data-uv-gal-next]');
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    }

    /* ---- offer tiers ---- */
    var tiers = Array.prototype.slice.call(document.querySelectorAll('[data-uv-tier]'));
    var qty = document.querySelector('[data-uv-qty]');
    var priceEl = document.querySelector('[data-uv-atc-price]');
    var wasEl = document.querySelector('[data-uv-atc-was]');
    tiers.forEach(function (tier) {
      tier.addEventListener('click', function () {
        tiers.forEach(function (t) {
          t.classList.remove('is-on');
          Array.prototype.forEach.call(t.querySelectorAll('.uv-gift'), function (g) { g.classList.remove('uv-gift--on'); });
          var r = t.querySelector('.uv-tier__radio'); if (r) r.checked = false;
        });
        tier.classList.add('is-on');
        Array.prototype.forEach.call(tier.querySelectorAll('.uv-gift'), function (g) { g.classList.add('uv-gift--on'); });
        var radio = tier.querySelector('.uv-tier__radio'); if (radio) radio.checked = true;
        if (qty) qty.value = tier.getAttribute('data-qty') || 1;
        if (priceEl) priceEl.textContent = tier.getAttribute('data-price') || '';
        if (wasEl) wasEl.textContent = tier.getAttribute('data-compare') || '';
      });
    });

    /* ---- gifts as real line items ----
       A plain form post can only carry one line item. When the selected tier
       has gift variants, add the whole set through the cart AJAX API instead
       and then go to checkout. If anything fails we fall through to the normal
       form post, so the pillow still reaches the cart. */
    var form = document.querySelector('[data-uv-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        var tier = document.querySelector('[data-uv-tier].is-on');
        if (!tier) return;
        var gifts = (tier.getAttribute('data-gifts') || '').split(',').filter(Boolean);
        var picks = tier.querySelectorAll('[data-uv-pick-sel]');
        /* Nothing to intercept for: no gifts and no per-unit colours. */
        if (!gifts.length && !picks.length) return;

        e.preventDefault();
        var btn = form.querySelector('[data-uv-atc]');
        if (btn) btn.disabled = true;

        var items = [];
        if (picks.length) {
          /* One row per unit; identical colours collapse into one line item so
             the cart reads "Grey x2" rather than two separate Grey lines. */
          var tally = {};
          Array.prototype.forEach.call(picks, function (sel) {
            tally[sel.value] = (tally[sel.value] || 0) + 1;
          });
          Object.keys(tally).forEach(function (id) {
            items.push({ id: id, quantity: tally[id] });
          });
        } else {
          items.push({ id: form.querySelector('[name="id"]').value,
                       quantity: parseInt(qty && qty.value, 10) || 1 });
        }
        gifts.forEach(function (id) { items.push({ id: id, quantity: 1 }); });

        /* Empty the cart first. /cart/add.js appends, so picking a tier twice
           (or coming back and picking a different one) used to leave a cart
           matching no tier at all — five pillows, and quantity discounts
           applying to a total the visitor never chose. The tier selector is a
           statement of the whole order, so it should replace, not accumulate. */
        fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          });
        }).then(function (r) {
          if (!r.ok) throw new Error(r.status);
          if (form.querySelector('[name="return_to"]')) { window.location = '/checkout'; return; }

          /* The bag must be re-fetched before it is shown: clicking the bag
             icon only opens whatever the drawer last rendered, which is the
             pre-add (empty) state. The theme exposes refresh() for this. */
          var api = window.alineCart;
          if (!api || typeof api.open !== 'function') { window.location = '/cart'; return; }

          function showBag() {
            try { api.open(); } catch (err) { window.location = '/cart'; return; }
            if (btn) btn.disabled = false;
            /* Never strand the visitor if the drawer failed to appear. */
            setTimeout(function () {
              var dr = document.querySelector('[data-cart-drawer],.cart-drawer');
              if (!dr || !dr.classList.contains('is-open')) window.location = '/cart';
            }, 900);
          }

          if (typeof api.refresh === 'function') {
            var done = false;
            var go = function () { if (!done) { done = true; showBag(); } };
            try {
              var res = api.refresh();
              if (res && typeof res.then === 'function') { res.then(go, go); }
              else { setTimeout(go, 350); }        /* refresh() is sync/void */
            } catch (err) { go(); }
            setTimeout(go, 1500);                   /* belt and braces */
          } else {
            showBag();
          }
        }).catch(function () {
          if (btn) btn.disabled = false;
          form.submit();                                  /* pillow only, but it works */
        });
      });
    }

    /* ---- colour: top swatches set the default for every unit in every pack,
           and each pack row can then be changed individually ---- */
    function paintPick(sel) {
      var row = sel.closest('[data-uv-pick]');
      var img = row && row.querySelector('[data-uv-pick-img]');
      var opt = sel.options[sel.selectedIndex];
      if (img && opt && opt.getAttribute('data-img')) img.src = opt.getAttribute('data-img');
    }
    var allPicks = document.querySelectorAll('[data-uv-pick-sel]');
    Array.prototype.forEach.call(allPicks, function (sel) {
      sel.addEventListener('change', function () { paintPick(sel); });
      paintPick(sel);
    });

    var opts = document.querySelectorAll('[data-uv-variant]');
    if (opts.length) {
      var hidden = document.querySelector('[data-uv-form] [name="id"]');
      Array.prototype.forEach.call(opts, function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          var id = btn.getAttribute('data-uv-variant');
          Array.prototype.forEach.call(opts, function (o) {
            o.classList.remove('is-on'); o.setAttribute('aria-checked', 'false');
          });
          btn.classList.add('is-on'); btn.setAttribute('aria-checked', 'true');
          if (hidden) hidden.value = id;
          Array.prototype.forEach.call(allPicks, function (sel) {
            sel.value = id;
            paintPick(sel);
          });
        });
      });
    }

    /* ---- clearance countdown ----
       Shares aline_offer_deadline with the header bar so the two can never
       disagree; falls back to its own length if no deadline exists yet. */
    var clear = document.querySelector('[data-uv-clear]');
    if (clear) {
      var hours = parseFloat(clear.getAttribute('data-hours')) || 5;
      var KEY = 'aline_offer_deadline', now = Date.now(), dl;
      try { dl = parseInt(localStorage.getItem(KEY), 10); } catch (e) {}
      var cap = now + hours * 3600000;
      /* also resets a deadline stored under a longer, earlier offer */
      if (!dl || isNaN(dl) || dl < now || dl > cap) {
        dl = cap;
        try { localStorage.setItem(KEY, dl); } catch (e) {}
      }
      var el = {
        h: clear.querySelector('[data-uv-clear="h"]'),
        m: clear.querySelector('[data-uv-clear="m"]'), s: clear.querySelector('[data-uv-clear="s"]')
      };
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var tick = function () {
        var left = Math.max(0, Math.floor((dl - Date.now()) / 1000));
        if (el.h) el.h.textContent = pad(Math.floor(left / 3600));
        if (el.m) el.m.textContent = pad(Math.floor(left % 3600 / 60));
        if (el.s) el.s.textContent = pad(left % 60);
      };
      tick();
      setInterval(tick, 1000);
    }

    /* ---- faq ---- */
    Array.prototype.forEach.call(document.querySelectorAll('[data-uv-faq]'), function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.uv-faq__i');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aline-uv-promo"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-uv-promo]');
    if (!root) return;
    var KEY = 'aline_uv_promo_seen';
    try { if (sessionStorage.getItem(KEY) === '1') return; } catch (e) {}

    var panel = root.querySelector('.uv-promo__panel');
    var closer = root.querySelector('.uv-promo__x');
    var last = null;

    function open() {
      last = document.activeElement;
      root.hidden = false;
      document.body.classList.add('uv-promo-open');
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      if (closer) closer.focus();
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    }
    function close() {
      root.classList.remove('is-open');
      document.body.classList.remove('uv-promo-open');
      setTimeout(function () { root.hidden = true; }, 280);
      if (last && last.focus) last.focus();
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-uv-promo-close]'), function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); close(); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });
    if (panel) panel.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = panel.querySelectorAll('button, [href], input:not([type="hidden"])');
      if (!f.length) return;
      var first = f[0], lastEl = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
    });

    var delay = parseInt(root.getAttribute('data-delay'), 10);
    setTimeout(open, isNaN(delay) ? 6000 : delay);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aline-uv-reveal"] && !Shopify.designMode) return;
  try {
    
  /* The range input is the source of truth; the wipe is just a CSS variable it
     writes. Keeps drag, keyboard and assistive tech on one code path. */
  (function () {
    document.querySelectorAll('[data-uv-reveal]').forEach(function (frame) {
      var input = frame.querySelector('[data-uv-reveal-input]');
      if (!input) return;
      var paint = function () { frame.style.setProperty('--reveal', input.value + '%'); };
      input.addEventListener('input', paint);
      paint();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aline-uv-reviews"]) return;
  try {
    
  /* "Read more reviews" reveals the next batch rather than linking away. */
  (function () {
    var btn = document.querySelector('[data-uv-rev-more]');
    if (!btn) return;
    var step = parseInt(btn.getAttribute('data-step'), 10) || 6;
    function hidden() { return Array.prototype.slice.call(document.querySelectorAll('[data-uv-rev].is-hidden')); }
    if (!hidden().length) { btn.parentElement.classList.add('is-done'); return; }
    btn.addEventListener('click', function () {
      hidden().slice(0, step).forEach(function (c) { c.classList.remove('is-hidden'); });
      if (!hidden().length) btn.parentElement.classList.add('is-done');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aline-uv-stats"]) return;
  try {
    
  /* Desktop rail for the research strip. On mobile the section is a static
     checkerboard grid with no overflow, so the controls stay hidden and idle. */
  (function () {
    document.querySelectorAll('[data-uv-statrail]').forEach(function (rail) {
      var root = rail.closest('section');
      var dots = root.querySelector('[data-uv-dots]');
      var items = Array.prototype.slice.call(rail.children);
      if (items.length < 2) return;
      function step() {
        var a = items[0].getBoundingClientRect();
        var b = items[1].getBoundingClientRect();
        return Math.round(b.left - a.left) || Math.round(a.width);
      }
      function pages() {
        var per = Math.max(1, Math.round(rail.clientWidth / (step() || 1)));
        return Math.max(1, Math.ceil(items.length / per));
      }
      function build() {
        if (!dots) return;
        dots.innerHTML = '';
        var n = pages();
        for (var i = 0; i < n; i++) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'uv__dot' + (i === 0 ? ' is-on' : '');
          d.setAttribute('aria-label', 'Page ' + (i + 1));
          (function (k) { d.addEventListener('click', function () {
            rail.scrollTo({ left: k * rail.clientWidth, behavior: 'smooth' }); }); })(i);
          dots.appendChild(d);
        }
      }
      build();
      window.addEventListener('resize', build);
      var raf;
      rail.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          if (!dots || !dots.children.length) return;
          var i = Math.round(rail.scrollLeft / (rail.clientWidth || 1));
          Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-on', k === i); });
        });
      }, { passive: true });
      var p = root.querySelector('[data-uv-prev]'), n2 = root.querySelector('[data-uv-next]');
      if (p) p.addEventListener('click', function () { rail.scrollBy({ left: -rail.clientWidth, behavior: 'smooth' }); });
      if (n2) n2.addEventListener('click', function () { rail.scrollBy({ left: rail.clientWidth, behavior: 'smooth' }); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aline-uv-sticky"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-uv-sticky]');
    if (!bar) return;

    var dismissed = false;
    try { dismissed = sessionStorage.getItem('aline_uv_sticky_closed') === '1'; } catch (e) {}
    if (dismissed) { bar.parentNode && bar.parentNode.removeChild(bar); return; }

    var closeBtn = bar.querySelector('[data-uv-sticky-close]');
    if (closeBtn) closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      dismissed = true;
      bar.classList.remove('is-visible');
      try { sessionStorage.setItem('aline_uv_sticky_closed', '1'); } catch (e2) {}
    });

    var cta = bar.querySelector('[data-uv-sticky-cta]');
    if (cta) cta.addEventListener('click', function () {
      /* Land on the pack list itself, not the scarcity line above it, and
         centre it in the space the sticky bar leaves — otherwise the visitor
         arrives with only the first pack in view. */
      var target = document.querySelector('.uv-tiers')
                || document.querySelector('#uv-offer')
                || document.querySelector('[data-uv-atc]');
      if (!target) return;
      var usable = window.innerHeight - bar.getBoundingClientRect().height;
      var h = target.getBoundingClientRect().height;
      var pad = h < usable ? Math.max(16, (usable - h) / 2) : 16;
      var y = window.pageYOffset + target.getBoundingClientRect().top - pad;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    });

    /* Reveal only once the real add-to-cart is above the viewport. */
    var addBtn = document.querySelector('[data-uv-atc]');
    function check() {
      if (dismissed || !addBtn) return;
      bar.classList.toggle('is-visible', addBtn.getBoundingClientRect().bottom < 0);
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();

    /* Same key as the header bar and the buy box, so they never disagree. */
    var KEY = 'aline_offer_deadline',
        days = parseFloat(bar.getAttribute('data-days')) || 3,
        now = Date.now(), dl;
    try { dl = parseInt(localStorage.getItem(KEY), 10); } catch (e3) {}
    var cap = now + days * 86400000;
    if (!dl || isNaN(dl) || dl < now || dl > cap) {
      dl = cap;
      try { localStorage.setItem(KEY, dl); } catch (e4) {}
    }
    var h = bar.querySelector('[data-uv-sticky-clock="h"]'),
        m = bar.querySelector('[data-uv-sticky-clock="m"]'),
        s = bar.querySelector('[data-uv-sticky-clock="s"]');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = Math.max(0, Math.floor((dl - Date.now()) / 1000));
      if (h) h.textContent = pad(Math.floor(left / 3600));
      if (m) m.textContent = pad(Math.floor(left % 3600 / 60));
      if (s) s.textContent = pad(left % 60);
    }
    tick();
    setInterval(tick, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aline-uv-tokens"]) return;
  try {
    
  /* Shared looping rail for the Uvola-style carousels.

     Arrows previously did nothing when the cards happened to fill the row
     exactly (nothing to scroll), and dead-ended one step in when they only
     just overflowed. Cloning the full set before and after the originals and
     rebasing on settle means every rail pages forever, whatever the count.

     Manual only — nothing here advances on its own. */
  (function () {
    document.querySelectorAll('[data-uv-loop]').forEach(function (rail) {
      var root = rail.closest('section');
      var dots = root.querySelector('[data-uv-dots]');
      var reals = Array.prototype.slice.call(rail.children);
      var n = reals.length;
      if (n < 2) {
        var nav = root.querySelector('[data-uv-nav]');
        if (nav) nav.style.display = 'none';
        return;
      }

      function cloneSet(where) {
        var frag = document.createDocumentFragment();
        reals.forEach(function (c) {
          var k = c.cloneNode(true);
          k.setAttribute('data-clone', '');
          k.setAttribute('aria-hidden', 'true');
          frag.appendChild(k);
        });
        if (where === 'before') rail.insertBefore(frag, reals[0]);
        else rail.appendChild(frag);
      }
      cloneSet('before');
      cloneSet('after');

      function step() {
        var a = rail.children[0].getBoundingClientRect();
        var b = rail.children[1].getBoundingClientRect();
        return Math.round(b.left - a.left) || Math.round(a.width);
      }
      function setWidth() { return step() * n; }
      function home() { rail.scrollLeft = setWidth(); }
      requestAnimationFrame(home);
      window.addEventListener('resize', function () { requestAnimationFrame(home); });

      if (dots) {
        reals.forEach(function (_, i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'uv__dot' + (i === 0 ? ' is-on' : '');
          d.setAttribute('aria-label', 'Slide ' + (i + 1));
          d.addEventListener('click', function () {
            rail.scrollTo({ left: setWidth() + i * step(), behavior: 'smooth' });
          });
          dots.appendChild(d);
        });
      }

      function settle() {
        var w = setWidth();
        if (w) {
          var delta = 0;
          if (rail.scrollLeft < w * 0.5) delta = w;
          else if (rail.scrollLeft > w * 1.5) delta = -w;
          if (delta) {
            /* scroll-snap: mandatory reverts a scrollLeft set while it is live */
            var prev = rail.style.scrollSnapType;
            rail.style.scrollSnapType = 'none';
            rail.scrollLeft += delta;
            setTimeout(function () { rail.style.scrollSnapType = prev; }, 60);
          }
        }
        paint();
      }

      /* The indicator used to update only inside settle(), i.e. 90ms after the
         scroll stopped, so it snapped over well after the cards had moved.
         Painting on every scroll frame lets the fill travel with them. */
      var seen = -1, was = 0;
      function paint() {
        if (!dots || !dots.children.length) return;
        var x = rail.scrollLeft;
        if (x !== was) { dots.setAttribute('data-dir', x < was ? 'back' : 'fwd'); was = x; }
        var i = Math.round((x - setWidth()) / (step() || 1));
        i = ((i % n) + n) % n;
        if (i === seen) return;
        seen = i;
        Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-on', k === i); });
      }

      var t, raf;
      rail.addEventListener('scroll', function () {
        if (!raf) raf = requestAnimationFrame(function () { raf = null; paint(); });
        clearTimeout(t);
        t = setTimeout(settle, 90);
      }, { passive: true });

      var prev = root.querySelector('[data-uv-prev]'), next = root.querySelector('[data-uv-next]');
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Publishes the floating header's height so a hero can slide up underneath it
     and still pad its own content clear. Measured rather than hard-coded — the
     pill changes height across breakpoints and once the brand font loads. */
  (function () {
    var hdr = document.querySelector('[data-header]');
    if (!hdr) return;
    function sync() {
      document.documentElement.style.setProperty('--header-h', hdr.offsetHeight + 'px');
    }
    sync();
    window.addEventListener('resize', sync, { passive: true });

    /* The bag bubble is noise at zero. Watch the count the cart script writes
       rather than taking over from it. */
    var badge = hdr.querySelector('.site-header__count');
    if (badge && window.MutationObserver) {
      var show = function () { badge.hidden = (parseInt(badge.textContent, 10) || 0) === 0; };
      show();
      new MutationObserver(show).observe(badge, { childList: true, characterData: true, subtree: true });
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync).catch(function () {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.pcMainReady) return;
      root.dataset.pcMainReady = '1';

      var stage  = root.querySelector('[data-pc-stage]');
      var slides = root.querySelectorAll('[data-pc-slide]');
      var thumbs = root.querySelectorAll('[data-pc-thumb]');
      var dotWrap = root.querySelector('[data-pc-dots]');
      var buy    = root.querySelector('[data-pc-buy]');
      var totalEl = root.querySelector('[data-pc-total]');
      var saveEl  = root.querySelector('[data-pc-save]');

      /* ---- gallery ---- */
      var dots = [];
      if (dotWrap && slides.length > 1) {
        for (var i = 0; i < slides.length; i++) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'pc-main__dot' + (i === 0 ? ' is-active' : '');
          d.setAttribute('aria-label', 'Imagen ' + (i + 1));
          (function (n) { d.addEventListener('click', function () { go(n); }); })(i);
          dotWrap.appendChild(d);
          dots.push(d);
        }
      }

      function paint(n) {
        for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === n);
        for (var j = 0; j < thumbs.length; j++) thumbs[j].classList.toggle('is-active', j === n);
      }
      function go(n) {
        if (!stage || !slides[n]) return;
        stage.scrollTo({ left: slides[n].offsetLeft - stage.offsetLeft, behavior: 'smooth' });
        paint(n);
      }
      for (var t = 0; t < thumbs.length; t++) {
        (function (btn) {
          btn.addEventListener('click', function () { go(Number(btn.getAttribute('data-pc-thumb'))); });
        })(thumbs[t]);
      }
      if (stage) {
        var tick = false;
        stage.addEventListener('scroll', function () {
          if (tick) return;
          tick = true;
          requestAnimationFrame(function () {
            tick = false;
            var mid = stage.scrollLeft + stage.clientWidth / 2, best = 0, bd = Infinity;
            for (var i = 0; i < slides.length; i++) {
              var c = slides[i].offsetLeft - stage.offsetLeft + slides[i].offsetWidth / 2;
              var dd = Math.abs(c - mid);
              if (dd < bd) { bd = dd; best = i; }
            }
            paint(best);
          });
        }, { passive: true });
      }

      /* ---- size ---- */
      var sizes = root.querySelectorAll('[data-pc-size]');
      for (var s = 0; s < sizes.length; s++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            if (btn.disabled) return;
            for (var k = 0; k < sizes.length; k++) {
              sizes[k].classList.remove('is-active');
              sizes[k].setAttribute('aria-checked', 'false');
            }
            btn.classList.add('is-active');
            btn.setAttribute('aria-checked', 'true');
            if (buy) buy.setAttribute('data-variant', btn.getAttribute('data-pc-size'));
          });
        })(sizes[s]);
      }

      /* ---- tiers ---- */
      var tiers = root.querySelectorAll('[data-pc-tier]');
      function syncTiers() {
        var chosen = null;
        for (var i = 0; i < tiers.length; i++) {
          var lbl = tiers[i].closest('.pc-main__tier');
          if (lbl) lbl.classList.toggle('is-active', tiers[i].checked);
          if (tiers[i].checked) chosen = tiers[i];
        }
        if (chosen) {
          if (totalEl) totalEl.textContent = chosen.getAttribute('data-price') || '';
          if (saveEl)  saveEl.textContent  = chosen.getAttribute('data-save') || '';
        }
      }
      for (var y = 0; y < tiers.length; y++) tiers[y].addEventListener('change', syncTiers);
      syncTiers();

      /* ---- buy ---- */
      if (buy) {
        buy.addEventListener('click', function () {
          var id = buy.getAttribute('data-variant');
          if (!id) return;
          var qty = 1;
          for (var i = 0; i < tiers.length; i++) if (tiers[i].checked) qty = Number(tiers[i].value) || 1;
          if (buy.dataset.busy) return;
          buy.dataset.busy = '1';
          var label = buy.textContent;
          buy.textContent = 'Añadiendo…';

          fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
            .then(function () {
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
              });
            })
            .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
            .then(function () { window.location.href = '/checkout'; })
            .catch(function () {
              buy.textContent = label;
              delete buy.dataset.busy;
              window.location.href = '/cart';
            });
        });
      }
    }

    function boot() {
      var all = document.querySelectorAll('.pc-main');
      for (var i = 0; i < all.length; i++) init(all[i]);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc-offer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pc-add]');
    if (!btn) return;

    var id = btn.getAttribute('data-variant');
    var qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
    if (!id) return;

    e.preventDefault();
    if (btn.dataset.busy) return;
    btn.dataset.busy = '1';
    var label = btn.textContent;
    btn.textContent = 'Añadiendo…';

    // Clear first: /cart/add.js appends, so a second click would stack tiers.
    fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
        });
      })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function () {
        btn.textContent = label;
        delete btn.dataset.busy;
        window.location.href = '/cart';
      });
  });

  } catch(e) { console.error(e); }
})();
})();
